module.exports = __webpack_public_path__ + "static/media/operador-logo-metlife.db76e7bc.svg";